/**
 * Create user at onboarding.
 *
 * @endpoint POST /api/me/onboarding
 * @scope shared
 * @see
 */

import { type CoreUserOnboardingPayload } from '@flecto/types'
import { api } from '../../../services/api'

export async function createUserOnboarding(body: {
  onboarding: CoreUserOnboardingPayload
}): Promise<void> {
  await api.post('/api/me/onboarding', body)
}
